import { AppState, PostPageWithTaboolaAppState } from '../../initialStateRegistration';

const getPostPage = (state: AppState) => (state as PostPageWithTaboolaAppState).template;

export const getShowTaboola = (state: AppState) => getPostPage(state).showTaboola;
